import { Component, inject, signal, computed, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-promos-trust',
  standalone: true,
  templateUrl: './promos-trust.component.html'
})
export class PromosTrustComponent implements OnInit {
  public state = inject(AppStateService);
  private platformId = inject(PLATFORM_ID);
  public router = inject(Router);
  
  public isClient = signal(false);
  public stakeBanner = computed(() => this.state.homeCms()?.stakeBanner);
  public walletBanner = computed(() => this.state.homeCms()?.walletBanner);
  public features = computed(() => this.state.homeCms()?.features || []);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isClient.set(true);
    }
  }
}
